module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/offline-report-5.30c6d442.svg";